import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  ATTACH_ACTION_SELECT_ACTION_FILE,
  AttachActionSelect,
} from '../../AttachActionSelect'
import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { FormActions } from '../../Form'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../Formik'
import { TASK_FORM_SERVICE_REQUEST_FIELD_NAME } from '../TaskForm'

import { TASK_FORM_ACTIONS_ATTACH_EMAIL_THREADS } from './TaskFormActions.constants'
import { getSelectOptions } from './TaskFormActions.utils'

function TaskFormActions({
  isMobileActions,
  isSubmitting,
  markAsDoneFieldName,
  uploadProps,
  onOpenEmailThreadsModal,
  ...restProps
}) {
  const { values } = useFormikContext()

  const { t } = useTranslation()

  const serviceRequest = values[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]

  const selectOptions = getSelectOptions({
    serviceRequestValue: serviceRequest,
    t,
  })

  function handleAttachAction(action) {
    switch (action.value) {
      case ATTACH_ACTION_SELECT_ACTION_FILE:
        // handling action in `AttachActionSelect`
        break
      case TASK_FORM_ACTIONS_ATTACH_EMAIL_THREADS:
        onOpenEmailThreadsModal()
        break
      default:
        return null
    }
  }

  return (
    <FormActions {...restProps}>
      <AttachActionSelect
        {...uploadProps}
        disabled={isSubmitting}
        options={selectOptions}
        onClick={handleAttachAction}
      />
      {!isMobileActions ? (
        <FormikField
          Component={Checkbox}
          Field={Fragment}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('Task.FormMarkAsDoneLabelKey')}
          name={markAsDoneFieldName}
          size={CHECKBOX_SIZE.small}
        />
      ) : null}
    </FormActions>
  )
}

export default TaskFormActions
